<template>
    <div :class="['grid-cell']" :style="style" :title="this.moment(localDate).format('DD-MM-YYYY')">
        <span v-if="title">{{ title }}</span>
        <span v-for="(title, index) in titles" :key="'title_' + index">
            {{ title }}
        </span>
    </div>
</template>

<script>
export default {
    name: 'GridCell',
    props: {
        date: {
            type: [String, Object],
        },
        classes: {
            type: String,
        },
        title: {
            type: String,
        },
        titles: {
            type: Array,
        },
        description: {
            type: String,
        },
        backgroundColor: {
            type: String,
        },
        textColor: {
            type: String,
        },
        data: {
            type: Object,
        },
        day: {
            type: Object,
        },
    },
    watch: {
        day: {
            deep: true,
            handler(day) {
                Object.keys(day).forEach((key) => (this[key] = day[key]));
            },
        },
    },
    computed: {
        style() {
            return `backgroundColor: ${this.localBackgroundColor};color: ${this.localTextColor};`;
        }
    },
    data() {
        return {
            localDate: '',
            localTitle: '',
            localDescription: '',
            localBackgroundColor: '',
            localTextColor: '',
            localData: {},
        };
    },
    beforeMount() {
        if (this.data) {
            this.localData = this.data;
        }
        if (this.date) {
            this.localDate = this.date;
        }

        if (this.title) {
            this.localTitle = this.title;
        }

        if (this.description) {
            this.localDescription = this.description;
        }

        if (this.backgroundColor) {
            this.localBackgroundColor = this.backgroundColor;
        }

        if (this.textColor) {
            this.localTextColor = this.textColor;
        }
    },
    methods: {
        reset() {
            this.day.reset();
        }
    }
};
</script>
